
.DayColumn {
    display: block;
    position: relative;
    border-left: solid 1px var(--soniq-t--global--border--color--column--default, #efefef);
}

.DayColumn.isToday {
    background-color: var(--soniq-t--global--background--color--accent--today--default);
}
